import React, { memo, useCallback } from 'react';
import { Text, useTheme } from '@Sage/hoi-poi-ui';

import { getLiteral } from 'utils/getLiteral';

const VARIANT_COPY = {
    html: {
        titleKey: 'label_marketing_campaigns_templates_start_scratch_html_editor',
    },
    visual: {
        titleKey: 'label_marketing_campaigns_templates_start_scratch_with_email_builder',
    },
};

/**
 * Blank starter card (HTML or visual builder).
 */
const CreateFromScratchCard = memo(({ variant, onSelect }) => {
    const theme = useTheme();
    const copy = VARIANT_COPY[variant];

    const handleClick = useCallback(() => {
        onSelect?.(variant);
    }, [onSelect, variant]);

    const handleKeyDown = useCallback(
        (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onSelect?.(variant);
            }
        },
        [onSelect, variant],
    );

    return (
        <div
            className="marketing-templates-create-from-scratch"
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
        >
            <div className="marketing-templates-create-from-scratch__thumb" aria-hidden />
            <div className="marketing-templates-create-from-scratch__meta">
                <Text
                    type="subtitle"
                    medium
                    className="marketing-templates-create-from-scratch__title"
                >
                    {getLiteral(copy.titleKey)}
                </Text>
                {copy.subtitleKey && (
                    <Text
                        type="caption"
                        color={theme.colors.textLight.secondary}
                        className="marketing-templates-create-from-scratch__desc"
                    >
                        {getLiteral(copy.subtitleKey)}
                    </Text>
                )}
            </div>
        </div>
    );
});

CreateFromScratchCard.displayName = 'CreateFromScratchCard';

export default CreateFromScratchCard;
